import React   from 'react';
import ViewTable from './view_table';
import ViewTree from './view_tree';
import ViewMulti from './view_multi';
import ViewHtml from "./view_html";
import ViewExporter from "./view_exporter";
import GraphComponent from '../graph/GraphComponent';


/** 
Страница просмотра результата
*/
class Show extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
	}
	
	render() {
		const view   = this.props.view;
		const model  = this.props.model;
		const filter = this.props.filter || null;
		switch (view.type) {
			case 'table':
			case 'list':
			case 'cmp':
				return (<ViewTable model={model} view={view} filter={filter} />);
			case 'tree':
				return (<ViewTree  model={model} view={view} />);
			case 'multi':
				return (<ViewMulti model={model} view={view} filter={filter} />);
			case 'graph':
				return (<GraphComponent model={model} view={view} />)
			case 'html':
				return (<ViewHtml view={view} />);
			case 'exporter':
				return (<ViewExporter model={model} view={view} />);
			default:
				throw 'illegal view type: ' + view.type;
		}
	}

}

export default Show;
